module.exports = __webpack_public_path__ + "static/media/iq.66216bd0.svg";